'use client';
// RouteWrapper - Wraps a route component with ErrorBoundary
import { RouteErrorBoundary } from './RouteErrorBoundary';

interface RouteWrapperProps {
  children: React.ReactNode;
  routeName: string;
}

export const RouteWrapper = ({ children, routeName }: RouteWrapperProps) => {
  return <RouteErrorBoundary routeName={routeName}>{children}</RouteErrorBoundary>;
};

export default RouteWrapper;
